import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import Question from './question'
import AddQuestionButton from './addQuestionButton'

const { Component } = React

const QuestionRowContainer = styled.div`
  margin-top: 10px;
  padding: 0px 10px;
`

const HorizontalFlex = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
`

class Questions extends Component {
  render () {
    if (!this.props.questions) {
      return (<QuestionRowContainer />)
    }

    let questions = this.props.questions.map((question) => {
      return (<Question
        key={question.id}
        question={question} />)
    })

    return (
      <QuestionRowContainer>
        <HorizontalFlex>
          {questions}
          <AddQuestionButton />
        </HorizontalFlex>
      </QuestionRowContainer>
    )
  }
}

const mapStateToProps = function (store, ownProps) {
  return {
    questions: store.questions,
    exampleMapId: store.exampleMap.id
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Questions)
